import { render, staticRenderFns } from "./ZoneParkings.vue?vue&type=template&id=65f1218c"
import script from "./ZoneParkings.vue?vue&type=script&lang=js"
export * from "./ZoneParkings.vue?vue&type=script&lang=js"
import style0 from "./ZoneParkings.vue?vue&type=style&index=0&id=65f1218c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports